import React, { useEffect, useRef, useState } from 'react';
import { ImNewTab } from 'react-icons/im';
import { MdArrowDropDown } from 'react-icons/md';
import { Link } from 'react-router-dom';

const DownloadDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        className="mt-6 flex flex-row rounded-[20px] bg-[#227D72] px-6 py-4 leading-[150%] text-white transition hover:bg-[#1e807e]"
        onClick={() => setIsOpen(!isOpen)}
      >
        Download Sample Report
        <MdArrowDropDown className="ml-2" size={20} />
      </button>

      {isOpen && (
        <div className="absolute left-0 z-50 w-80 rounded-[20px] border border-[#227D72] bg-white px-6 py-4 shadow-xl">
          <p className="mb-4 text-xs font-semibold uppercase">Download Sample</p>
          <ul className="flex flex-col gap-4">
            <li>
              <Link
                to="/reports/Property Improvement Plan Example 1.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 transition hover:text-[#227D72]"
              >
                <ImNewTab size={18} />
                <span className="font-medium">Improvement Report (PDF)</span>
              </Link>
            </li>
            <li>
              <Link
                to="/reports/Thermal Imaging Report Example 1.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 transition hover:text-[#248F8F]"
              >
                <ImNewTab size={18} />
                <span className="font-medium">Thermal Imaging Report (PDF)</span>
              </Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default DownloadDropdown;
